import en from './en';
import ms from './ms';
import zh from './zh';
import ta from './ta';

export const LANGS = [
    { code: 'ms', label: 'BM', native: 'Bahasa Melayu', og: 'ms_MY', htmlLang: 'ms-MY' },
    { code: 'en', label: 'EN', native: 'English', og: 'en_US', htmlLang: 'en' },
    { code: 'zh', label: '中文', native: '简体中文', og: 'zh_CN', htmlLang: 'zh-Hans' },
    { code: 'ta', label: 'தமிழ்', native: 'தமிழ்', og: 'ta_IN', htmlLang: 'ta' },
];

export const LANG_CODES = LANGS.map((l) => l.code);
export const DEFAULT_LANG = 'ms';

export const DICTS = { en, ms, zh, ta };
export const getDict = (code) => DICTS[code] || DICTS[DEFAULT_LANG];
export const isLangCode = (c) => Boolean(DICTS[c]);

export const langPath = (lang, path = '') => {
    const p = path === '/' ? '' : path || '';
    return `/dental/${lang}${p}`;
};

export const stripLang = (pathname) => {
    const p = (pathname || '').replace(/^\/dental/, '');
    const parts = p.split('/').filter(Boolean);
    if (parts.length && isLangCode(parts[0])) {
        return '/' + parts.slice(1).join('/');
    }
    return '/' + parts.join('/');
};
